import React, {Component} from 'react'
import PropTypes from 'prop-types'
import MarkRequest from './MarkRequest'
import SostaOnlineApiService from '../../../services/SostaOnlineApiService'
import { connect } from 'react-redux'
import { scroller } from 'react-scroll'
import moment from 'moment'
import {doLogin} from '../../../actions/auth'
import { Redirect } from 'react-router-dom'

class MarkRequestContainer extends Component {
  static propTypes = {
    auth: PropTypes.object
  }

  constructor (props) {
    super(props)
    this.state = {
      user: {},
      settings: [],
      markTypes: [],
      addresses: [],
      markRules: {},
      documents: [],
      loading: true,
      price: null,
      selectedMarkType: null,
      selectedVehicles: [],
      selectedDocuments: [],
      errors: null,
      vehicleOwnershipTypes: [],
      vehiclePowerSupplies: [],
      submitting: false,
      selectedUserCategory: null,
      userAdjustment: null
    }

    this.onDocumentSelect = this.onDocumentSelect.bind(this)
    this.onMarkTypeSelected = this.onMarkTypeSelected.bind(this)
    this.onVehicleSelected = this.onVehicleSelected.bind(this)
    this.onVehicleAdd = this.onVehicleAdd.bind(this)
    this.onVehicleRemove = this.onVehicleRemove.bind(this)
    this.onDocumentAdd = this.onDocumentAdd.bind(this)
    this.onDocumentRemove = this.onDocumentRemove.bind(this)
    this.onVehicleOwnershipTypeChange = this.onVehicleOwnershipTypeChange.bind(this)
    this.onVehiclePowerSupplyChange = this.onVehiclePowerSupplyChange.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onDocumentChange = this.onDocumentChange.bind(this)
  }

  async fetchInitialData () {
    this.setState({loading: true})
    const userResponse = await SostaOnlineApiService.fetchUserMe()
    const settingsResponse = await SostaOnlineApiService.fetchPublicSettings()
    const { data: user } = userResponse
    const { categories, workArea, residenceArea } = user

    let areaIds = []
    if (workArea) {
      areaIds.push(workArea.id)
    }

    if (residenceArea) {
      areaIds.push(residenceArea.id)
    }

    const markTypesResponse = await SostaOnlineApiService.fetchMarkTypesByCategoryAndAreaIds(
      categories.map(item => item.id + ','),
      areaIds.map(item => item + ',')
    )

    const vehicleOwnershipTypes = await SostaOnlineApiService.fetchVehicleOwnershipTypes()
    const vehiclePowerSupplies = await SostaOnlineApiService.fetchVehiclePowerSupplies()
    const userAdjustment = await SostaOnlineApiService.fetchAdjustmentMe()

    this.fetchAddresses()
    this.setState({
      user: user,
      settings: settingsResponse.data,
      markTypes: markTypesResponse.data,
      vehicleOwnershipTypes: vehicleOwnershipTypes.data,
      vehiclePowerSupplies: vehiclePowerSupplies.data,
      userAdjustment: userAdjustment.data,
      loading: false
    })
  }

  fetchAddresses () {
    this.setState({loading: true})
    SostaOnlineApiService.fetchAddresses().then((data) => {
      this.setState({
        addresses: data.data,
        loading: false
      })
    })
  }

  getUserMatchingCategories (categories) {
    return this.state.user.categories.filter(item => categories.filter(cI => cI.id === item.id).length > 0)
  }

  getSettingByName (name) {
    const { settings } = this.state
    const foundSettings = settings.filter(item => item.name === name)
    if (foundSettings.length === 0) {
      return null
    }

    return foundSettings[0]
  }

  async componentDidMount () {
    await this.fetchInitialData()
  }

  getUserMarksByTypeId (markType) {
    const today = moment()
    return this.state.user.marks.filter(item => {
      const endDate = moment(item.endDate)
      const isExpired = today.diff(endDate, 'days') > 0
      return item.markTypeId === markType.id && !item.archived && !item.ceased && !isExpired
    })
  }

  printVehiclesPowerSupplies (vehicles) {
    let string = ''
    vehicles.map((item, index) => {
      string = string + item.VehiclePowerSupply.id

      if (index < vehicles.length - 1) {
        string = string + ','
      }
    })
    return string
  }

  async updatePrice () {
    this.setState({errors: null})
    try {
      const matchingCategories = this.getUserMatchingCategories(this.state.selectedMarkType.Categories)
      let promises = matchingCategories.map((item) => {
        const p = SostaOnlineApiService.fetchMarkPrice(
          this.state.user.id,
          this.state.selectedMarkType.id,
          item.id,
          null,
          this.printVehiclesPowerSupplies(this.state.selectedVehicles)
        )
        return p
      })

      const prices = await Promise.all(promises)
      if (prices.filter(item => item.result !== 'ok').length > 0) {
        this.setState({errors: 'errore durante la ricezione dei prezzi'})
      }

      let lowestPrice = prices[0].data
      prices.map(item => {
        if (item.data.price < lowestPrice) {
          lowestPrice = item.data
        }
      })

      this.setState({price: lowestPrice})
    } catch (ex) {
      this.setState({errors: 'Errore durante l\'elaborazione dei prezzi'})
    }
  }

  async onMarkTypeSelected (markType) {
    try {
      const rules = await SostaOnlineApiService.fetchMarkRulesByMarkType(markType.id)
      if (rules.data.length === 0) {
        this.setState({errors: 'Impossibile scaricare le regole del contrassegno'})
        return
      }

      const documentsTypes = await SostaOnlineApiService.fetchDocumentTypesByMarkTypeId(markType.id)
      /* if (documentsTypes.data.length === 0) {
        this.setState({errors: 'Impossibile scaricare i tipi di documenti'})
        return
      } */

      if (this.getUserMarksByTypeId(markType).length >= rules.data[0].marksLimit) {
        this.setState({errors: 'Hai già superato il numero massimo di contrassegni attivi per il tuo tipo di utente'})
        return
      }

      this.setState({
        markRules: rules.data[0],
        documents: documentsTypes.data.map(item => {
          return {
            documentTypeId: item.id,
            slug: item.slug,
            typeName: item.name,
            vehiclePlateNumber: null,
            document: null
          }
        }),
        selectedMarkType: markType
      }, () => {
        if (this.state.selectedVehicles.filter(item => item !== '').length > 0) {
          this.updatePrice()
        }
        scroller.scrollTo('step-two', {
          duration: 1000,
          delay: 100,
          smooth: true
        })
      })
    } catch (ex) {
      this.setState({error: 'Errore imprevisto'})
    }
  }

  onDocumentSelect (e, index) {
    const newDocuments = this.state.documents
    newDocuments[index].document = e.currentTarget.files[0]
    this.setState({documents: newDocuments})
  }

  onVehicleSelected (vehicle, index) {
    let newSelectedVehicles = [...this.state.selectedVehicles]
    newSelectedVehicles[index] = vehicle
    this.setState({selectedVehicles: newSelectedVehicles}, async () => {
      if (vehicle.type !== 'new') {
        await this.updatePrice()
      }
    })
  }

  onVehicleRemove (index) {
    this.setState({selectedVehicles: this.state.selectedVehicles.filter((_, i) => i !== index)}, () => {
      if (this.state.selectedVehicles.length > 0) {
        this.updatePrice()
      } else {
        this.setState({price: null})
      }
    })
  }

  onVehicleAdd () {
    if (this.state.markRules.vehicleLimit === this.state.selectedVehicles.length) {
      return
    }
    this.setState({selectedVehicles: [...this.state.selectedVehicles, {}]})
  }

  onDocumentChange (document, index) {
    const {selectedDocuments} = this.state
    const newDocuments = selectedDocuments.map((item, i) => {
      if (i === index) {
        return document
      } else {
        return item
      }
    })
    this.setState({selectedDocuments: newDocuments})
  }

  onDocumentRemove (index) {
    this.setState({selectedDocuments: this.state.selectedDocuments.filter((_, i) => i !== index)})
  }

  onDocumentAdd () {
    this.setState({selectedDocuments: [...this.state.selectedDocuments, {}]})
  }

  onVehicleOwnershipTypeChange (e, index) {
    let newSelectedVehicles = [...this.state.selectedVehicles]
    newSelectedVehicles[index].VehicleOwnershipType = {id: e.target.value}
    this.setState({selectedVehicles: newSelectedVehicles}, () => this.updatePrice())
  }

  onVehiclePowerSupplyChange (e, index) {
    let newSelectedVehicles = [...this.state.selectedVehicles]
    newSelectedVehicles[index].VehiclePowerSupply = {id: e.target.value}
    this.setState({selectedVehicles: newSelectedVehicles}, () => this.updatePrice())
  }

  async onSubmit (values) {
    const { submitting, selectedVehicles, selectedMarkType, price, selectedDocuments } = this.state

    if (submitting) {
      return
    }

    /* const uploadingDocuments = {}
    // validiamo i documenti, se ne manca qualcuno ritorniamo errore
    for (let i = 0; i < documents.length; i++) {
      const document = documents[i]
      if (document.slug === 'carta_circolazione_veicoli') {
        for (let iV = 0; iV < selectedVehicles.length; iV++) {
          const vehicle = selectedVehicles[iV]
          if (!values['documentFile-' + vehicle.plate_number.toLowerCase()]) {
            this.setState({
              errors: 'Il documento: ' + document.typeName + ' per il veicolo: ' + vehicle.plate_number + ' è obbligatorio.'
            })
            return
          } else {
            uploadingDocuments[vehicle.plate_number.toLowerCase()] = {}
            uploadingDocuments[vehicle.plate_number.toLowerCase()][document.documentTypeId] = values['documentFile-' + vehicle.plate_number.toLowerCase()].id
          }
        }
      } else {
        if (!values['documentFile-' + document.documentTypeId]) {
          this.setState({
            errors: 'Il documento: ' + document.typeName + ' è obbligatorio.'
          })
          return
        } else {
          uploadingDocuments[document.documentTypeId] = values['documentFile-' + document.documentTypeId].id
        }
      }
    } */

    try {
      this.setState({submitting: true, errors: null})
      const response = await SostaOnlineApiService.createMarkMe({
        vehicles: selectedVehicles,
        markTypeId: selectedMarkType.id,
        categoryId: price.category.id,
        startAddressId: values.startAddress,
        documents: selectedDocuments.map(item => item.id)
      })
      if (response.result !== 'ok') {
        this.setState({
          errors: 'Errore durante la richiesta del contrassegno',
          submitting: false
        })
      } else {
        this.setState({
          submitting: false
        })
        this.props.history.push('/user-area/marks')
      }
    } catch (e) {
      console.log(e)
      this.setState({submitting: false, errors: e.error || 'Errore imprevisto durante la richiesta del contrassegno'})
    }
  }

  render () {
    const {
      markTypes,
      loading,
      selectedMarkType,
      documents,
      errors,
      user,
      selectedVehicles,
      vehicleOwnershipTypes,
      vehiclePowerSupplies,
      markRules,
      price,
      submitting,
      addresses,
      userAdjustment,
      selectedDocuments
    } = this.state

    return (
      <React.Fragment>
        {(!loading && ((userAdjustment && userAdjustment.payed) || !userAdjustment)) && (
          <MarkRequest
            user={user}
            addresses={addresses}
            onMarkTypeSelected={async (item) => { await this.onMarkTypeSelected(item) }}
            selectedMarkType={selectedMarkType}
            selectedVehicles={selectedVehicles}
            markExpirationDate={this.getSettingByName('MarkExpirationDate_' + selectedMarkType.id)}
            documents={documents}
            onDocumentSelect={this.onDocumentSelect}
            errors={errors}
            onVehicleSelected={this.onVehicleSelected}
            vehicleOwnershipTypes={vehicleOwnershipTypes}
            vehiclePowerSupplies={vehiclePowerSupplies}
            loading={loading}
            onVehicleAdd={this.onVehicleAdd}
            onVehicleRemove={this.onVehicleRemove}
            onVehiclePowerSupplyChange={this.onVehiclePowerSupplyChange}
            onVehiclePropertyTypeChange={this.onVehicleOwnershipTypeChange}
            price={price}
            onSubmit={this.onSubmit}
            markRules={markRules}
            submitting={submitting}
            markTypes={markTypes}
            selectedDocuments={selectedDocuments}
            onDocumentAdd={this.onDocumentAdd}
            onDocumentRemove={this.onDocumentRemove}
            onDocumentChange={this.onDocumentChange}
          />
        )}
        {(!loading && userAdjustment && !userAdjustment.payed) && (
          <Redirect to="/" />
        )}
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth
})

const mapDispatchToProps = (dispatch) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(MarkRequestContainer)



// WEBPACK FOOTER //
// ./src/containers/UserArea/MarkRequest/MarkRequestContainer.js